<template>
  <div ref="line" class="line"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LineCharts',
  props: {
    title: {
      type: String,
      default: ''
    },
    list_x: {
      type: Array,
      default: () => []
    },
    series_name: {
      type: String,
      default: ''
    },
    list_y: {
      type: Array,
      default: () => []
    },
    series_name2: {
      type: String,
      default: ''
    },
    list_y2: {
      type: Array,
      default: () => []
    },
    dataType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
    const myChart = echarts.init(this.$refs.line)
    let dataType = this.dataType;
    let series = [];
    if (this.list_y && this.list_y.length > 0) {
      series.push({
        name: this.series_name,
        type: 'line',
        smooth: true,
        data: this.list_y,
        // 折线拐点样式
        itemStyle: {
          opacity: 0
        },
        // 折线的样式
        lineStyle: {
          color: '#5c7bd9'
        },
        // 区域填充颜色
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#5c7bd9' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#e9f5fe' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        }
      });
    }
    if (this.list_y2 && this.list_y2.length > 0) {
      series.push({
        name: this.series_name2,
        type: 'line',
        smooth: true,
        data: this.list_y2,
        // 折线拐点样式
        itemStyle: {
          opacity: 0
        },
        // 折线的样式
        lineStyle: {
          color: '#9fe080'
        },
        // 区域填充颜色
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#9fe080' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#f3fef1' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        }
      });
    }
    myChart.setOption({
      title: {
        subtext: this.title,
        left: 'center'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          let str = '';
          let index = 0;
          params.forEach(item => {
            let value = item.value;
            if (!!dataType && dataType == 'percent') {
              value = parseFloat((value * 100).toFixed(2)) + '%'
            }
            if (index == 0) {
              str += item.name;
            }
            str +=  "<br />" + item.marker + item.seriesName + "：" + value;
            index++;
          })
          return str;
        }
      },
      xAxis: {
        show: false,
        type: 'category',
        data: this.list_x,
        axisTick: {
          alignWithLabel: true,
          show: true
        },
        axisLabel: { interval: 0, rotate: 30, show: true },
        axisLine: {
          //坐标轴轴线
          show: true
        }
      },
      yAxis: {
        show: false
      },
      series: series,
      grid: {
        left: '0%',
        right: '0%',
        top: '30%',
        bottom: '5%'
      }
    })
  },
  methods: {}
}
</script>

<style lang="css" scoped>
.line {
  width: 100%;
  height: 100%;
}
</style>
